import React from 'react';
const CoachingClasses = () => <div className="service-page"><h1>Coaching Classes</h1><p>Coaching classes for competitive exams and school subjects.</p></div>;
export default CoachingClasses;
